import { Injectable, OnDestroy, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LessonsFilter } from './lessons-filter';
import { AppUtilsModule } from '../app-utils.module';
import { ActivatedRoute } from '@angular/router';
import { YeshivaEnums } from 'src/serverTypes/yeshivaTypesEnums';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppGlobalsModule } from '../app-globals.module';
import { AngularPages, UrlAddressService } from '../core/services/url-address/url-address.service';
import { BrowserPlatformService } from '../core/services/browser-platform/browser-platform.service';
//import { AngularApp } from '../serverTypes/yeshivaTypes';

@Injectable()
export class LessonsFilterService implements OnDestroy {
    private route = inject(ActivatedRoute);
    private routeTo = inject(Router);
    private location = inject(Location);
    urlAddress = inject(UrlAddressService);
    private _browser = inject(BrowserPlatformService);

    private filter: LessonsFilter = new LessonsFilter();
    public filterApplied = false;
    public flippedToDesc = false;
    public ascNotFromSeries = true;
    public AngularPages = AngularPages;
    // Filter Changes observable source
    private filterChangedSource = new BehaviorSubject<LessonsFilter>(new LessonsFilter());
    // Filter Changes bservable stream
    filterChanges = this.filterChangedSource.asObservable();

    ngOnDestroy(): void {
        if (this.filterChangedSource) this.filterChangedSource.unsubscribe();
    }

    setFilterFromQuaryParams() {
        //set global filter by initial params
        var params = this.route.snapshot.queryParamMap;

        if (params.keys.length == 0) {
            return;
        }

        let quaryFilter = this.getAppliedFilter();
        if (quaryFilter == null) {
            quaryFilter = new LessonsFilter();
        }
        //cat -- need to be removed and redirect to category page
        let catId = params.get('catId') ?? params.get('catid');
        if (catId) {
            quaryFilter.catId = parseInt(catId);
        }

        //rabbi
        if (/*quaryFilter.filtRabbis.length == 0 &&*/ params.has('rabbi')) {
            var urlRabbis = params.get('rabbi')?.split(',') ?? [];
            urlRabbis.forEach((rav) => {
                if (!quaryFilter.filtRabbis.includes(parseInt(rav))) {
                    quaryFilter.filtRabbis.push(parseInt(rav));
                }
            });
        }
        let maxlength = params.get('maxlength');
        if (maxlength) {
            quaryFilter.filtMaxLength = parseInt(maxlength);
        }
        let minlength = params.get('minlength');
        if (minlength) {
            quaryFilter.filtMinLength = parseInt(minlength);
        }
        let ber = params.get('ber');
        if (ber) {
            //BET EL RABBIS IDS, FOR PAGE WITH THERE LESSONS
            if (parseInt(ber) != 1) {
                var rabbisString = ber;
                var urlRabbis = rabbisString.split(',');
                urlRabbis.forEach((rav) => {
                    if (!quaryFilter.filtRabbis.includes(parseInt(rav))) {
                        quaryFilter.filtRabbis.push(parseInt(rav));
                    }
                });
            } else {
                // go to bet ell rabbis in c# to get yeshivat bet ell rabbis from midrashView. the controller will redirect to filter page with yeshiva rabbis list
                this._browser.location?.assign(`/midrash/yberavs?ber=1`);
                return;
            }
        }
        //filter
        let fltr = params.get('filter');
        if (fltr) {
            //abort exist format filters
            quaryFilter.unFiltFormat();

            if (fltr.includes('video')) {
                quaryFilter.filtVideo = true;
            }
            if (fltr.includes('audio') || fltr.includes('mp3')) {
                quaryFilter.filtAudio = true;
            }
            if (fltr.includes('pdf')) {
                quaryFilter.filtPDF = true;
            }
            if (fltr.includes('txt')) {
                //use txt to filter all read filters
                quaryFilter.filtRead(true);
            }
        }
        let fltrContentType = params.get('contype');
        if (fltrContentType) {
            quaryFilter.unFiltContentType();
            if (fltrContentType.includes('woman')) {
                quaryFilter.filtWomanLesson = true;
            }
            if (fltrContentType.includes('child')) {
                quaryFilter.filtChildLesson = true;
            }
            if (fltrContentType.includes('general')) {
                quaryFilter.filtGeneralLesson = true;
            }
        }

        //orderby as order
        let od = params.get('order');
        if (od) {
            var orderCode = parseInt(od);
            //for old parameters
            if (orderCode == -1) {
                quaryFilter.orderBy = YeshivaEnums.AngularApp.API.enums.OrderBy.dateUp;
            } else if (orderCode == -2) {
                quaryFilter.orderBy = YeshivaEnums.AngularApp.API.enums.OrderBy.length;
            } else {
                quaryFilter.orderBy = orderCode as YeshivaEnums.AngularApp.API.enums.OrderBy;
            }
        }

        //desc
        if (params.has('desc')) {
            if (params.get('desc') == 'true') {
                quaryFilter.order = YeshivaEnums.AngularApp.API.enums.Order.desc;
            } else {
                quaryFilter.order = YeshivaEnums.AngularApp.API.enums.Order.asc;
            }
        }

        //search
        if (params.has('q')) {
            //redirect to search page
            this._browser.location?.replace(`/search?q=${params.get('q')}`);
            //quaryFilter.searchTerm = params.get("q");
        }

        //page
        let pg = params.get('page');
        if (pg) {
            quaryFilter.page = parseInt(pg);
        }
        this.setFilter(quaryFilter);
    }

    setFilterFromStorageParams() {
        //set global filter by initial params
        var params = this.route.snapshot.queryParamMap;

        if (params.keys.length == 0) {
            return;
        }

        let quaryFilter = this.getAppliedFilter();
        if (quaryFilter == null) {
            quaryFilter = new LessonsFilter();
        }
        //cat -- need to be removed and redirect to category page
        let catId = params.get('catId') ?? params.get('catid');
        if (catId) {
            quaryFilter.catId = parseInt(catId);
        }

        //rabbi
        if (/*quaryFilter.filtRabbis.length == 0 &&*/ params.has('rabbi')) {
            var urlRabbis = params.get('rabbi')?.split(',') ?? [];
            urlRabbis.forEach((rav) => {
                if (!quaryFilter.filtRabbis.includes(parseInt(rav))) {
                    quaryFilter.filtRabbis.push(parseInt(rav));
                }
            });
        }
        let maxlength = params.get('maxlength');
        if (maxlength) {
            quaryFilter.filtMaxLength = parseInt(maxlength);
        }
        let minlength = params.get('minlength');
        if (minlength) {
            quaryFilter.filtMinLength = parseInt(minlength);
        }
        let ber = params.get('ber');
        if (ber) {
            //BET EL RABBIS IDS, FOR PAGE WITH THERE LESSONS
            if (parseInt(ber) != 1) {
                var rabbisString = ber;
                var urlRabbis = rabbisString.split(',');
                urlRabbis.forEach((rav) => {
                    if (!quaryFilter.filtRabbis.includes(parseInt(rav))) {
                        quaryFilter.filtRabbis.push(parseInt(rav));
                    }
                });
            } else {
                // go to bet ell rabbis in c# to get yeshivat bet ell rabbis from midrashView. the controller will redirect to filter page with yeshiva rabbis list
                this._browser.location?.assign(`/midrash/yberavs?ber=1`);
                return;
            }
        }
        //filter
        let fltr = params.get('filter');
        if (fltr) {
            //abort exist format filters
            quaryFilter.unFiltFormat();

            if (fltr.includes('video')) {
                quaryFilter.filtVideo = true;
            }
            if (fltr.includes('audio') || fltr.includes('mp3')) {
                quaryFilter.filtAudio = true;
            }
            if (fltr.includes('pdf')) {
                quaryFilter.filtPDF = true;
            }
            if (fltr.includes('txt')) {
                //use txt to filter all read filters
                quaryFilter.filtRead(true);
            }
        }
        //contype
        let fltrContentType = params.get('contype');
        if (fltrContentType) {
            quaryFilter.unFiltContentType();

            if (fltrContentType.includes('woman')) {
                quaryFilter.filtWomanLesson = true;
            }
            if (fltrContentType.includes('child')) {
                quaryFilter.filtChildLesson = true;
            }
            if (fltrContentType.includes('general')) {
                quaryFilter.filtGeneralLesson = true;
            }
        }
        //orderby as order
        let od = params.get('order');
        if (od) {
            var orderCode = parseInt(od);
            //for old parameters
            if (orderCode == -1) {
                quaryFilter.orderBy = YeshivaEnums.AngularApp.API.enums.OrderBy.dateUp;
            } else if (orderCode == -2) {
                quaryFilter.orderBy = YeshivaEnums.AngularApp.API.enums.OrderBy.length;
            } else {
                quaryFilter.orderBy = orderCode as YeshivaEnums.AngularApp.API.enums.OrderBy;
            }
        }

        //desc
        if (params.has('desc')) {
            if (params.get('desc') == 'true') {
                quaryFilter.order = YeshivaEnums.AngularApp.API.enums.Order.desc;
            } else {
                quaryFilter.order = YeshivaEnums.AngularApp.API.enums.Order.asc;
            }
        }

        //search
        if (params.has('q')) {
            //redirect to search page
            this._browser.location?.replace(`/search?q=${params.get('q')}`);
            //quaryFilter.searchTerm = params.get("q");
        }

        //page
        let pg = params.get('page');
        if (pg) {
            quaryFilter.page = parseInt(pg);
        }
        this.setFilter(quaryFilter);
    }
    setUrlFromFilter(quaryFilter: LessonsFilter) {
        if (AppGlobalsModule.isServer) {
            return;
        }

        let myQueryParams: { [key: string]: any } = {};

        if (quaryFilter != null) {
            if (quaryFilter.filtRabbis.length > 0 && quaryFilter.filtRabbis.length < 4) {
                myQueryParams['rabbi'] = '';
                quaryFilter.filtRabbis.forEach((rav: any) => {
                    myQueryParams['rabbi'] += rav + ',';
                });
                if (myQueryParams['rabbi'].endsWith(',')) {
                    myQueryParams['rabbi'] = myQueryParams['rabbi'].substring(0, myQueryParams['rabbi'].length - 1);
                }
            } else if (quaryFilter.filtRabbis.length > 3) {
                myQueryParams['ber'] = 1;
            }

            if (quaryFilter.filtMinLength && quaryFilter.filtMinLength >= 0) {
                myQueryParams['minlength'] = quaryFilter.filtMinLength;
            }
            if (quaryFilter.filtMaxLength && quaryFilter.filtMaxLength <= 80) {
                myQueryParams['maxlength'] = quaryFilter.filtMaxLength;
            }

            //TODO: seperate category page and filter page so cat will be a parameter in filter page
            // if (quaryFilter.catId != null)
            // {
            //     myQueryParams["cat"]= quaryFilter.catId;
            // }

            if (quaryFilter.filtVideo || quaryFilter.filtAudio || quaryFilter.filtTxt || quaryFilter.filtDoc || quaryFilter.filtPDF) {
                myQueryParams['filter'] = '';
                if (quaryFilter.filtVideo) {
                    myQueryParams['filter'] += 'video,';
                }
                if (quaryFilter.filtAudio) {
                    myQueryParams['filter'] += 'audio,';
                }
                // if (quaryFilter.filtPDF)
                // {
                //     myQueryParams["filter"]+="pdf,";
                // }
                if (quaryFilter.filtTxt || quaryFilter.filtDoc || quaryFilter.filtPDF) {
                    myQueryParams['filter'] += 'txt,';
                }

                if (myQueryParams['filter'].endsWith(',')) {
                    myQueryParams['filter'] = myQueryParams['filter'].substring(0, myQueryParams['filter'].length - 1);
                }
            }
            if (quaryFilter.filtWomanLesson || quaryFilter.filtChildLesson || quaryFilter.filtGeneralLesson) {
                myQueryParams['contype'] = '';
                if (quaryFilter.filtWomanLesson) {
                    myQueryParams['contype'] += 'woman,';
                }
                if (quaryFilter.filtChildLesson) {
                    myQueryParams['contype'] += 'child,';
                }
                if (quaryFilter.filtGeneralLesson) {
                    myQueryParams['contype'] += 'general,';
                }
                if (myQueryParams['contype'].endsWith(',')) {
                    myQueryParams['contype'] = myQueryParams['contype'].substring(0, myQueryParams['contype'].length - 1);
                }
            }

            if (quaryFilter.order === YeshivaEnums.AngularApp.API.enums.Order.desc && this.flippedToDesc) {
                myQueryParams['desc'] = 'true';
            }
            if (quaryFilter.order === YeshivaEnums.AngularApp.API.enums.Order.asc && this.ascNotFromSeries) {
                myQueryParams['desc'] = 'false';
            }
            // if (quaryFilter.orderBy == YeshivaEnums.AngularApp.API.enums.OrderBy.dateUp)
            // {
            //     myQueryParams["order"]=-1;
            // }
            if (quaryFilter.orderBy == YeshivaEnums.AngularApp.API.enums.OrderBy.length) {
                myQueryParams['order'] = -2;
            }

            if (quaryFilter.page != null && quaryFilter.page > 1) {
                myQueryParams['page'] = quaryFilter.page;
            }
            //TODO: use ContentAreaService - problem with cross app service providers
            let pagePath = `/${AppGlobalsModule.areaPath()}/`;
            if (quaryFilter.catId) {
                if (this._browser.location?.pathname.includes('series')) {
                    pagePath += 'series';
                } else {
                    pagePath += 'filter';
                }
                myQueryParams['catId'] = this.filter.catId;
                // } else {
                //     pagePath += `category/${this.filter.catId}`;
                // }
            } else {
                if (this._browser.location?.pathname.includes('series')) {
                    pagePath += 'series';
                } else {
                    pagePath += 'filter';
                }
            }

            let newUrl = this.routeTo
                .createUrlTree([pagePath], {
                    queryParams: myQueryParams,
                })
                .toString();
            // if (document.location.pathname.includes('category') && !quaryFilter.catId) {
            //     this.routeTo.navigate([pagePath], {
            //         //relativeTo:this.activatedRoute
            //     });
            // } else {
            this.location.go(newUrl);
            // }
        }
    }

    setFilter(newFilter: LessonsFilter) {
        this.filter = AppUtilsModule.deepCopyObj(newFilter);
        ('');
        this.filterApplied = true;
        this.filterChangedSource.next(this.filter);
    }

    //TODO: waht is this function????
    setHistogramFilter(newFilter: LessonsFilter) {
        this.filter = AppUtilsModule.deepCopyObj(newFilter);
        this.filterApplied = true;
        this.filterChangedSource.next(this.filter);
    }
    resetFilter(update: boolean = true) {
        this.filter = new LessonsFilter();
        this.filterApplied = false;
        if (update) {
            this.filterChangedSource.next(this.filter);
        }
    }

    getAppliedFilter(): LessonsFilter | null {
        if (this.filterApplied) {
            var copy = AppUtilsModule.deepCopyObj(this.filter);
            return copy;
        }

        return null;
    }
}
